var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M12 1.25a10.75 10.75 0 110 21.5 10.75 10.75 0 010-21.5zm0 1.5a9.25 9.25 0 100 18.5 9.25 9.25 0 000-18.5zm4.44 4.75a.75.75 0 011.12 1l-6.87 7.6-.1.08c-.5.46-1.3.43-1.76-.09l-2.39-2.63a.75.75 0 111.12-1.01l2.2 2.43z"}})}
var staticRenderFns = []

export { render, staticRenderFns }